import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { ScopeObjectType } from '~/types';
import { POLICYTYPE } from '~/modules/common/enums';
import useCostCenters from '~/modules/common/enhancers/useCostCenters';
import { onChange } from '../enhancers/facetHelpers';

import GroupFacetDetails from '../GroupFacetDetails';

export const CostCenterFacetDetails = ({
  className,
  selected,
  setSelected,
  policy = POLICYTYPE.PROJECT_MANAGEMENT,
  scope
}) => {
  const { formatMessage } = useIntl();
  const [searchTerm, setSearchTerm] = useState('');

  const noneOptionText = formatMessage({
    id: 'costCenterDropdown.noCostCenter'
  });
  const { costCenters, loading, hasMore } = useCostCenters({
    searchTerm,
    policy,
    includeNoneOption: true,
    noneOptionText,
    scope
  });

  return (
    <GroupFacetDetails
      label={formatMessage({ id: 'search.costCenter' })}
      className={className}
      selected={selected}
      onChange={onChange}
      setSelected={setSelected}
      isLoading={loading}
      setSearchTerm={setSearchTerm}
      options={costCenters}
      noOptionsLabel={formatMessage({ id: 'costCenterDropdown.noCostCenter' })}
      hasMore={hasMore}
      optionTypeText={formatMessage({
        id: 'moreOptions.costCenter'
      })}
    />
  );
};

CostCenterFacetDetails.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  scope: PropTypes.oneOf(Object.values(ScopeObjectType)),
  policy: PropTypes.oneOf([
    POLICYTYPE.PROJECT_MANAGEMENT,
    POLICYTYPE.PORTFOLIO_MANAGEMENT,
    POLICYTYPE.RESOURCE_MANAGEMENT,
    POLICYTYPE.REVENUE_MANAGEMENT
  ])
};

export default CostCenterFacetDetails;
